export function assignModel<T extends object>(target: T, model: Partial<T>) {
  (Object.keys(model) as (keyof T)[]).forEach((key) => {
    target[key] = model[key] as T[keyof T];
  });
}

export function assignModelField<T extends object>(target: T, model: Partial<T>, key: string) {
  const field = key as keyof T;

  target[field] = model[field] as T[keyof T];
}
